<template>
  <div>
    <template>
      <smallheader></smallheader>
    </template>
    <div style="width: 1200px;margin: 0 auto;margin-top:20px;padding-bottom:20px;display:flex;">
      <div style="font-size:14px;color:#888;display:flex;align-items: center">
        <img src="@/assets/resource/adresst.png" style="width:15px;height:15px;margin-right:5px" />
        当前位置：
      </div>
      <span style="cursor: pointer;font-size:14px" @click="retrun">问卷调查 / 问卷详情</span>
    </div>

    <div class="box">
      <div class="topictitle">{{ questionObject.name }}</div>
      <div class="topic__type-des">{{ questionObject.description }}</div>

      <fieldset class="messagevote">
        <div class="form" v-for="(item, index) in titleData" :key="index">
          <div>
            <div></div>
            <div id="divTitle1">
              <span>{{ index + 1 }}.</span>
              {{ item.name }}
              <span v-if="item.type=='1'">(单选)</span>
              <span v-else-if="item.type=='2'">(多选)</span>
              <span v-else>(问答)</span>
            </div>
          </div>

          <!-- 单选 -->
          <div v-if="item.type == '1' ? true : false">
            <!-- type为1是单选，2是多选 -->
            <ul class="ulradiocheck">
              <li
                style="width: 99%"
                v-for="items in item.choiceList"
                :key="items.id"
                @click="radiosChange(items, item.id)"
              >
                <input
                  type="radio"
                  :name="item.id"
                  :id="items.id"
                  :value="items.name"
                  @click="radiosChange(items, item.id)"
                  style="margin-right:10px"
                />
                <label :for="items.id">{{items.name }}</label>
                <div v-if="items.isIdea" class="disinput">
                  <div class="addRedEnd" v-if="items.isMust"></div>
                  <el-input
                    class="disinputText"
                    v-model="items.idea"
                    type="text"
                    placeholder="请填写意见"
                  ></el-input>
                </div>
              </li>
            </ul>
          </div>

          <!-- 多选 -->
          <div v-if="item.type == '2' ? true : false">
            <ul>
              <li
                style="width: 99%;margin-left: 20px;margin-top:8px"
                v-for="items in item.choiceList"
                :key="items.id"
              >
                <input
                  type="checkbox"
                  :name="item.id"
                  :id="items.id"
                  :value="items.name"
                  @click="radiosChange(items)"
                  :label="items.checked"
                  style="margin-right:10px"
                />
                <label :for="items.id">{{ items.name}}</label>
                <div v-if="items.isIdea" class="disinput">
                  <div class="addRedEnd" v-if="items.isMust"></div>
                  <el-input
                    class="disinputText"
                    v-model="items.idea"
                    type="text"
                    placeholder="请填写意见"
                  ></el-input>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="item.type=='3'? true : false">
            <textarea
              class="texta"
              @input="newVal(index,item.answer)"
              v-model="item.answer"
              placeholder="请输入答案"
              id
              cols="150"
              rows="10"
            ></textarea>
          </div>
        </div>
      </fieldset>
    </div>
    <div style="text-align:center">
      <el-button type="primary" style="margin-bottom:20px" @click="goto">提交</el-button>
    </div>
  </div>
</template>
<script>
import * as vote from '@/api/vote/vote.js';
import smallheader from '../../smallHeader/index';
import { getInfo, setInfo } from '@/utils/auth';
export default {
  components: {
    smallheader,
  },
  data() {
    return {
      questionObject: [], //主题的信息
      titleData: [], //题目的信息
      StudentId: '',
      dialogVisible: false,
      htmltitle: '',
    };
  },
  created() {
    this.questionsingle();
  },
  methods: {
    newVal(index, v) {
      this.titleData[index].answer = v;
    },
    retrun() {
      this.$router.go(-1);
    },
    //获取当前问卷主题的信息
    questionsingle() {
      let id = { id: this.$route.query.id };
      vote.getPollTopicModel(id).then((res) => {
        this.questionObject = res.result;
        this.htmltitle = res.result.name;
        this.getTitle(res.result.id);
      });
    },
    // 获取题目信息
    getTitle(id) {
      let a = { topicId: id };
      vote.GetQuestionInfoList(a).then((res) => {
        this.titleData = res.result;
        // console.log(this.titleData);
      });
    },
    // prePhone(){
    //   this.$router.push({
    //         path: '/diaoy/prePhone',
    //         query:{           //路由传参时push和query搭配使用 ，作用时传递参数
    //             id:this.$route.query.id,
    //         }
    //     })
    // },

    radiosChange(item, topicId) {
      // item是选项  ，topicId是 题目id
      // val.Checked=true;
      let obj = {};
      if (topicId != null) {
        //单选按钮
        for (let i = 0; i < this.titleData.length; i++) {
          if (this.titleData[i].id == topicId) {
            obj = this.titleData[i];
          }
        }
        //先把题目循环出来，然后将每一道题目的选项在循环出来
        if (obj != null) {
          for (let j = 0; j < obj.choiceList.length; j++) {
            obj.choiceList[j].checked = false;
          }
        }
        item.checked = true;
      } else {
        //复选按钮
        item.checked = !item.checked;
      }
    },
    preview() {
      this.dialogVisible = true;
    },

    goto() {
      console.log(getInfo('storageObj'));
      let storageObj = getInfo('storageObj')
        ? JSON.parse(getInfo('storageObj'))
        : '';
      if (storageObj.length != 0) {
        for (let i = 0; i < storageObj.length; i++) {
          if (
            storageObj[i].userid == this.$store.state.User.ids &&
            storageObj[i].id == this.$route.query.id
          ) {
            this.$alert('您已经提交过，不能再提交！', {
              confirmButtonText: '确定',
              callback: (action) => {},
            });

            return false;
          }
        }
      }

      let num = 0;
      let nums = 0;
      // 循环所有题目，如果不是问答题就++，得的值就是单选加双选的值
      for (let i = 0; i < this.titleData.length; i++) {
        if (this.titleData[i].type != '3') {
          nums++;
        }
      }

      // 如果为填空题，并且为空，那么提示未完成
      // for (let i = 0; i < this.titleData.length; i++) {
      //   if (this.titleData[i].type == '3' && this.titleData[i].answer == '') {
      //     this.$message({
      //       message: '请选择完后提交！',
      //       type: 'error',
      //     });
      //     return false;
      //   }
      // }
      // 判断意见必填项
      for (let i = 0; i < this.titleData.length; i++) {
        if (this.titleData[i].type == '1' || this.titleData[i].type == '2') {
          for (let j = 0; j < this.titleData[i].choiceList.length; j++) {
            if (this.titleData[i].choiceList[j].checked) {
              if (this.titleData[i].choiceList[j].isMust == true) {
                if (this.titleData[i].choiceList[j].idea == '') {
                  this.$message({
                    message: '请填写必填意见！',
                    type: 'error',
                  });
                  return false;
                }
              }
            }
          }
        }
      }

      // 循环出单选和双选的数量去和nums比较
      for (let i = 0; i < this.titleData.length; i++) {
        for (let j = 0; j < this.titleData[i].choiceList.length; j++) {
          if (this.titleData[i].choiceList[j].checked == true) {
            num++;
            break;
          }
        }
      }

      if (num == nums) {
        if (this.$store.state.User.ids) {
          this.StudentId = this.$store.state.User.ids;
        } else {
          this.StudentId = 0;
        }
        vote
          .AddPollDataMore(this.$route.query.id, this.StudentId, this.titleData)
          .then((res) => {
            if (res.result !== 0) {
              if (res.message) {
                let list = getInfo('storageObj')
                  ? JSON.parse(getInfo('storageObj'))
                  : '';

                let storageObj = [];
                if (list.length != 0) {
                  storageObj = list;
                }

                list;
                let Obj = {
                  userid: this.$store.state.User.ids
                    ? this.$store.state.User.ids
                    : 0,
                  id: this.$route.query.id,
                };
                storageObj.push(Obj);

                setInfo('storageObj', storageObj);
                this.$message({
                  message: '投票成功！',
                  type: 'success',
                });
                // 提交成功后清除所有input标签的选中状态
                var temp = document.getElementsByTagName('input');
                for (let i = 0; i < temp.length; i++) {
                  temp[i].checked = false;
                }
                for (let i = 0; i < this.titleData.length; i++) {
                  for (
                    let j = 0;
                    j < this.titleData[i].choiceList.length;
                    j++
                  ) {
                    this.titleData[i].choiceList[j].checked = false;
                  }
                }
                this.$alert('您的答卷已经提交，感谢您的参与！', {
                  confirmButtonText: '确定',
                  callback: (action) => {
                    if (this.questionObject.isOpen) {
                      this.$router.push(
                        '/diaoy/statistics?topicId=' + this.$route.query.id
                      );
                    } else {
                      this.$router.go(-1);
                    }
                  },
                });
              }
            } else {
              this.$message({
                message: '此问卷以提交过一次',
                type: 'warning',
              });
            }
          });
      } else {
        this.$message({
          message: '请选择完后提交！',
          type: 'error',
        });
      }
    },
  },
};
</script>
<style scoped>
.box {
  width: 1200px;
  margin: 0 auto;
  min-height: 600px;

  background-color: #ffffff;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-radius: 5px;
  border: 1px solid rgba(242, 242, 242, 1);
}
.topictitle {
  font: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Microsoft YaHei',
    'Microsoft YaHei UI', '微软雅黑', sans-serif;
  padding-top: 26px;
  padding: 26px 10px 15px;
  color: #1ea0fa;
  text-align: center;
  font-size: 22px;
}
.title {
  font-size: 20px;
  line-height: 32px;
  font-weight: bold;
  margin: 0;
  padding: 0;
  text-align: center;
}
.topic__type-des {
  font-size: 16px;
  margin: 0 20px;
  padding: 10px 0 20px 0;
  border-bottom: 1px solid #f7f7f7;
}
.texta {
  margin-top: 15px;
  border: 1px solid #f2f2f2;
  padding: 5px 8px;
  font-size: 14px;
}

.req {
  color: red;
  font-weight: bold;
  position: absolute;
  top: 3px;
  left: -10px;
}
fieldset {
  margin: 0 20px;
}
#divTitle1 {
  font-size: 16px;
  margin-top: 10px;
}
.ulradiocheck {
  padding-top: 10px;
  padding-left: 20px;
}
.ulradiocheck li {
  font-size: 14px;
  margin-top: 8px;
}
.addRedEnd:after {
  content: '*';
  color: red;
  font-size: 18px;
}
.form {
  margin-top: 20px;
}
.disinput {
  display: flex;
}
.disinputText {
  width: 400px;
}
/deep/ .el-input__inner {
  height: 33px;
  line-height: 33px;
  padding: 0 5px;
}
</style>